import React, { Fragment } from 'react';
import './Messages.scss'
import HrbTranslate from '../../../../components/language/HrbTranslate';
import MessagingWindow from './MessagingWindow';
import ContentPlain from '../../../../components/layout/ContentPlain';
import HelpLink from '../../../../components/library/common/HelpLink';

const Messages = () => {
    return (
        <Fragment>
            <ContentPlain elementId='messages-description'>
                <div className='columns messages'>
                    <div className='column is-8 is-offset-1'>
                        <div>
                            <h3><HrbTranslate text='Messages.Title' /></h3>
                            <HrbTranslate text='Messages.Description' className='p1' />
                        </div>
                    </div>
                    <div className='column is-2 pt-4'>
                        <HelpLink helpKey='0ProSupport/VDOPro/MessageTemplates.htm' textKey='App.MessageTemplatesLinkText' />
                    </div>
                </div>
            </ContentPlain >
            <MessagingWindow />
        </Fragment>
    )
}

Messages.whyDidYouRender = false;

export default Messages